import NgrxAuth from '../../auth/Auth'
import { CALL_API } from '../../util/RBRestMiddleware'
import { UPDATE_CLAIM } from './submitAClaimActions'
import { ClaimTypes } from '../SubmitClaim/Common'

export const INITIAL_PRACTITIONERS_LOADING = 'INITIAL_PRACTITIONERS_LOADING'
export const INITIAL_PRACTITIONERS_SUCCESS = 'INITIAL_PRACTITIONERS_SUCCESS'
export const INITIAL_PRACTITIONERS_FAILED = 'INITIAL_PRACTITIONERS_FAILED'

export const SEARCH_PRACTITIONERS_LOADING = 'SEARCH_PRACTITIONERS_LOADING'
export const SEARCH_PRACTITIONERS_SUCCESS = 'SEARCH_PRACTITIONERS_SUCCESS'
export const SEARCH_PRACTITIONERS_FAILED = 'SEARCH_PRACTITIONERS_FAILED'

export const GET_OTHER_PRACTITIONERS_LOADING = 'GET_OTHER_PRACTITIONERS_LOADING'
export const GET_OTHER_PRACTITIONERS_SUCCESS = 'GET_OTHER_PRACTITIONERS_SUCCESS'
export const GET_OTHER_PRACTITIONERS_FAILED = 'GET_OTHER_PRACTITIONERS_FAILED'

export const UPDATE_OTHER_PRACTITIONERS_LOADING = 'UPDATE_OTHER_PRACTITIONERS_LOADING'
export const UPDATE_OTHER_PRACTITIONERS_SUCCESS = 'UPDATE_OTHER_PRACTITIONERS_SUCCESS'
export const UPDATE_OTHER_PRACTITIONERS_FAILED = 'UPDATE_OTHER_PRACTITIONERS_FAILED'

export const ADD_CLINIC_LOADING = 'ADD_CLINIC_LOADING'
export const ADD_CLINIC_SUCCESS = 'ADD_CLINIC_SUCCESS'
export const ADD_CLINIC_FAILED = 'ADD_CLINIC_FAILED'

export const EDIT_CLINIC_LOADING = 'EDIT_CLINIC_LOADING'
export const EDIT_CLINIC_SUCCESS = 'EDIT_CLINIC_SUCCESS'
export const EDIT_CLINIC_FAILED = 'EDIT_CLINIC_FAILED'

export const DELETE_PRACTITIONER_LOADING = 'DELETE_PRACTITIONER_LOADING'
export const DELETE_PRACTITIONER_SUCCESS = 'DELETE_PRACTITIONER_SUCCESS'
export const DELETE_PRACTITIONER_FAILED = 'DELETE_PRACTITIONER_FAILED'

// practitioner has no ability to edit from api
export const ADD_PRACTITIONER_LOADING = 'ADD_PRACTITIONER_LOADING'
export const ADD_PRACTITIONER_SUCCESS = 'ADD_PRACTITIONER_SUCCESS'
export const ADD_PRACTITIONER_FAILED = 'ADD_PRACTITIONER_FAILED'

export const CLEAR_SEARCH = 'CLEAR_SEARCH'

// practititioner
export const fetchInitalPractitioners = (type) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/clinics/${type}`,
        prefix: 'INITIAL_PRACTITIONERS',
        method: 'get'
      }
    })
  }
}
export const searchPractitioners = (searchObj) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/searchPractitionerByCategoryAndPhoneNumberAndPostalCode`,
        prefix: 'SEARCH_PRACTITIONERS',
        method: 'post',
        query: searchObj
      }
    })
  }
}
export const postClinic = (clinicObj, clinicType, onSuccess) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/addClinic/${clinicType}`,
        prefix: 'ADD_CLINIC',
        method: 'post',
        onSuccess: onSuccess,
        query: clinicObj
      }
    })
  }
}

export const editClinic = (clinicObj, onSuccess) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/updateClinic`,
        prefix: 'EDIT_CLINIC',
        method: 'post',
        onSuccess: onSuccess,
        query: clinicObj
      }
    })
  }
}

export const postPractitioner = (pracObj, pracType, onSuccess) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/clinics/${pracType}`,
        prefix: 'ADD_PRACTITIONER',
        method: 'post',
        onSuccess: onSuccess,
        query: pracObj
      }
    })
  }
}

export const deletePreviouslyUsedPractitioner = (clinicId, onSuccess) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/clinics/${clinicId}`,
        prefix: 'DELETE_PRACTITIONER',
        method: 'delete',
        onSuccess
      }
    })
  }
}

export const clearSearch = () => {
  return {
    type: CLEAR_SEARCH
  }
}

/**
 * Set a practioner as selected. this is coming from the components/SubmitAClaim/practioner.js
 *
 * @param {string} claimType - the claim type, currently should be Dental or something else such as Drug. There are no consts for this
 * @param {boolean} isNewClinic - if it's a new clinic that was searched
 * @param {any} practionerRowItem - the practitioner selected from the row, not sure how to validate this so cross your fingers and jump on one foot :P
 * @returns {any}
 */
export const setSelectedPractioner = (claimType, isNewClinic, practionerRowItem) => {
  let updatedClaimObject = {}
  switch (claimType) {
    case ClaimTypes.DRUG:
    case ClaimTypes.DRUG_FR:
      updatedClaimObject = {
        isNewClinic,
        PractitionerFirstName: practionerRowItem.firstName || 'firstName',
        PractitionerLastName: practionerRowItem.lastName || 'lastName',
        ClinicName: practionerRowItem.clinicName,
        RegistrationNumber: practionerRowItem.registrationNumber || 'newClinic',
        ContactInformation: {
          ...createClinicContactInformation(practionerRowItem)
        },
        ClinicInformationDrug: {
          ...createClinicContactInformation(practionerRowItem),
          ...createProviderAssignmentInformation(practionerRowItem),
          ClinicName: practionerRowItem.clinicName
        },
        'PharmacyName': practionerRowItem.clinicName
      }
      break
    case ClaimTypes.DENTAL:
    case ClaimTypes.DENTAL_FR:
      updatedClaimObject = {
        isNewClinic,
        PayTo: 'Certificate',
        ClinicInformationDental: {
          ...createClinicInformation(practionerRowItem)
        }
      }
      break
    case ClaimTypes.OTHER_EHC:
    case ClaimTypes.OTHER_EHC_FR:
      updatedClaimObject = {
        isNewClinic,
        PayTo: 'Certificate',
        ClinicInformationOtherExtendedHealthCare: {
          ...createClinicInformation(practionerRowItem),
          clinicName: practionerRowItem.clinicName
        }
      }
      break

    default:
      updatedClaimObject = {
        isNewClinic,
        PayTo: 'Certificate',
        ClinicInformationExtendedHealthCare: {
          ...createClinicInformation(practionerRowItem)
        }
      }
      break
  }

  return {
    type: UPDATE_CLAIM,
    claimObj: updatedClaimObject
  }
}
/**
 * clears the selected practioner from the claimObj and sets them to null
 *
 * @returns {any}
 */
export const clearSelectedPractioner = () => {
  let updatedClaimObject = {
    ClinicInformationDental: null,
    ClinicInformationOtherExtendedHealthCare: null,
    ClinicInformationExtendedHealthCare: null,
    ClinicInformationDrug: null,
    ClinicName: null,
    RegistrationNumber: null,
    ContactInformation: null
  }

  return {
    type: UPDATE_CLAIM,
    claimObj: updatedClaimObject
  }
}

/**
 * Private functions:
 */

const createClinicContactInformation = (practionerRowItem) => {
  return {
    AddressLine1: practionerRowItem.address || practionerRowItem.addressLine1,
    AddressLine2: null,
    City: practionerRowItem.city,
    PhoneNumber: practionerRowItem.phone,
    PostalCode: practionerRowItem.postalCode,
    Province: practionerRowItem.province,
    clinicId: practionerRowItem.clinicId
  }
}

const createPractitionerNameInformation = (practionerRowItem) => {
  return {
    FirstName: practionerRowItem.firstName,
    LastName: practionerRowItem.lastName
  }
}

const createPractitionerAssignmentInformation = (practionerRowItem) => {
  return {
    PractitionerAssignmentAuth: practionerRowItem.practitionerAssignmentAuth,
    PractitionerCode: practionerRowItem.practitionerCode
  }
}

const createProviderAssignmentInformation = (practionerRowItem) => {
  return {
    ProviderAssignmentAuth: practionerRowItem.providerAssignmentAuth,
    ProviderCode: practionerRowItem.providerCode
  }
}

const createClinicInformation = (practionerRowItem) => {
  return {
    ...createClinicContactInformation(practionerRowItem),
    ...createPractitionerNameInformation(practionerRowItem),
    ...createPractitionerAssignmentInformation(practionerRowItem),
    ...createProviderAssignmentInformation(practionerRowItem)
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/submitPractitionerActions.js